<template>
  <v-container class="pa-0" fluid>
    <FilterShippingProblem orderBy="Masalah Baru" :setFilter="setFilter"/>
    <v-sheet class="mb-5">
      <br>
      <v-data-table
        :headers="headers"
        :items="items"
        item-key="index"
        class="body"
        @click:row="rowClicked"
        :server-items-length="totalItems"
        :options.sync="pagination"
        :footer-props="{showCurrentPage: true, showFirstLastPage: true, 'items-per-page-options': $_item_per_page}"
        :loading="isLoading"
        :loading-text="$_strings.common.LOADING_TEXT"

      >
        <template v-slot:[`item.isCompleteByAdmin`]="{item}">
          <v-icon
            color="yellow accent-4"
            v-if="item.isCompleteByAdmin === false"
          >
            mdi-flag-triangle
          </v-icon>
          <v-icon
            color="red"
            v-else
          >
            mdi-flag-triangle
          </v-icon>
        </template>
        <template v-slot:[`item.accidentReason`]=items>
          <span style="">{{ items.item.accidentReason }}</span>
        </template>
        <template v-slot:[`item.shipmentGroupTitle`]=items>
          <span style="">{{ items.item.shipmentGroupTitle }}</span>
          <p class="ma-0">{{dateFormat(items.item.createdAt) }}</p>
        </template>
        <template v-slot:[`item.cargoTitle`]=items>
          <span style="">{{ items.item.cargoTitle }}</span>
        </template>
        <template v-slot:[`item.transporterName`]=items>
          <span style="">{{ items.item.transporterName }}</span>
          <br/>
          <span>{{ items.item.rekanan3PL }}</span>
        </template>
        <template v-slot:[`item.transportTypeName`]=items>
          <span style="">{{ items.item.transportTypeName }}</span>
          <br/>
          <span>{{ items.item.companyTransportNo }}</span>
        </template>
        <template v-slot:[`item.companyDriverName`]=items>
          <span style="">{{ items.item.companyDriverName }}</span>
          <br/>
          <span>{{ items.item.companyDriverPhone }}</span>
        </template>
        <template v-slot:[`item.action`]="{item}">
          <v-btn
            v-if="userAccess.canUpdate"
            color="primary"
            class="mr-2 ml-2"
            small
            @click.stop.prevent="setdialogAssignProblem(item)"
          >
            {{$_strings.shippingProblem.proses}}
          </v-btn>
        </template>
        <template v-slot:[`footer.page-text`]="props">
          <span>
            {{$_strings.shippingProblem.pageName}}
            <span v-if="items.length">
              {{props.pageStart}}-{{props.pageStop}} of {{props.itemsLength}}
            </span>
          </span>
        </template>
      </v-data-table>
    </v-sheet>
    <DialogAssignProblem
      :setDialogAssignProblem="setDialog"
      :dialogAssignProblem="dialogAssignProblem"
      :setAssignProblem="temporary"
      @fetchShippingProblem="fetchShippingProblem"
    />
  </v-container>
</template>

<script>
import {
  dateFormat,
  handleSortBy,
  handlerPagination,
  defaultPagination,
} from '@/helper/commonHelpers';
import DialogAssignProblem from '../Dialog/AssignProblem.vue';
import FilterShippingProblem from '../FilterShippingProblem.vue';

export default {
  name: 'shipping-problem-list-waiting',
  components: {
    FilterShippingProblem,
    DialogAssignProblem,
  },
  data() {
    return {
      componentCreated: false,
      isLoading: false,
      dialogAssignProblem: false,
      temporary: {},
      items: [],
      filter: {
        search: this.$route.query.search || '',
        accidentReason: this.$route.query.accidentReason || '',
      },
      headers: [
        {
          text: '',
          value: 'isCompleteByAdmin',
          class: 'white--text primary',
          cellClass: 'clickable',
        },
        {
          text: this.$_strings.shippingProblem.headerMasalah,
          value: 'accidentReason',
          class: 'white--text primary',
          cellClass: 'clickable',
        },
        {
          text: this.$_strings.shippingProblem.headerNokiriman,
          value: 'shipmentGroupTitle',
          class: 'white--text primary',
          cellClass: 'clickable',
        },
        {
          text: this.$_strings.shippingProblem.headerNoPesanan,
          value: 'cargoTitle',
          class: 'white--text primary',
          cellClass: 'clickable',
        },
        {
          text: this.$_strings.shippingProblem.headerRekanan3PL,
          value: 'transporterName',
          class: 'white--text primary',
          cellClass: 'clickable',
        },
        {
          text: this.$_strings.shippingProblem.headerKendaraan,
          value: 'transportTypeName',
          class: 'white--text primary',
          cellClass: 'clickable',
        },
        {
          text: this.$_strings.shippingProblem.headerSopir,
          value: 'companyDriverName',
          class: 'white--text primary',
          cellClass: 'clickable',
        },
        {
          text: 'Aksi',
          value: 'action',
          class: 'white--text primary action2',
          sortable: false,
        },
      ],
      expanded: [],
      pagination: this.defaultPagination(),
      totalItems: 0,
      historyPath: null,
    };
  },
  computed: {
    accidentExists() {
      return this.$store.getters['user/accidentExists'];
    },
  },
  watch: {
    $route: function setHistoryPath(newVal, oldVal) {
      if (oldVal.params.status === 'unconfirmed') {
        this.historyPath = oldVal.fullPath;
      }
    },
    '$route.path': function setQueryString() {
      const { status } = this.$route.params;
      const { query } = this.$route;
      if (status === 'unconfirmed' && !Object.keys(query).length) {
        this.$router.replace(this.historyPath);
      }
    },
    pagination: {
      handler(newVal) {
        this.handlerPagination(this, newVal);
        this.fetchShippingProblem();
      },
      deep: true,
    },
    accidentExists() {
      if (this.componentCreated) this.fetchShippingProblem();
    },
  },
  methods: {
    dateFormat,
    handleSortBy,
    handlerPagination,
    defaultPagination,
    toggleLoading(boolean) {
      if (this.items.length > 0) {
        this.isLoading = false;
        return boolean ? this.$root.$loading.show() : this.$root.$loading.hide();
      }
      this.$root.$loading.hide();
      this.isLoading = boolean;
    },
    fetchShippingProblem() {
      this.toggleLoading(true);
      const {
        page, itemsPerPage, sortBy, sortDesc,
      } = this.pagination;
      const status = 'NEW';
      const size = itemsPerPage;
      const sort = this.handleSortBy({ defaultValue: 'createdAt,DESC', sortBy, sortDesc });
      const { search, accidentReason } = this.filter;
      this.$_services.shippingProblem.getListShippingProblem({
        page: page - 1, size, sort, search, accidentReason,
      }, status)
        .then((res) => {
          this.items = res.data.contents;
          this.totalItems = res.data.totalData;
          this.componentCreated = true;
        })
        .finally(() => {
          this.toggleLoading(false);
        });
    },
    setDialog(dialog) {
      this[dialog] = !this[dialog];
    },
    setFilter(filterBy, value) {
      this.filter[filterBy] = value;
      if (this.$route.query[filterBy] !== value) {
        this.$router.replace(({
          name: this.$route.name,
          query: {
            ...this.$route.query,
            [filterBy]: value,
            page: 1,
          },
        }));
      }
      this.$emit('fetching', 'new');
    },
    setdialogAssignProblem(item) {
      this.temporary = item;
      this.setDialog('dialogAssignProblem');
    },
    async rowClicked(e, { item }) {
      try {
        this.$root.$loading.show();
        const res = await this.$_services.shippingProblem.getDetailShippingProblem(item.cargoAccidentId);
        this.$router.push({
          name: 'masalah-detail',
          params: {
            id: item.cargoAccidentId,
            data: res.data,
          },
          query: {
            shipmentGroupTitle: item.shipmentGroupTitle,
            status: 'Waiting',
          },
        });
      } finally {
        this.$root.$loading.hide();
      }
    },
  },
};
</script>
